import React from "react";
import { Flex, Box } from "reflexbox";
import { StaticImage } from "gatsby-plugin-image";

import * as colors from "../../styles/colors";

export function GuideAuthor({ publishedDate }) {
  return (
    <Flex alignItems="center" mt={[3]} mb={[2]}>
      <Box style={{ overflow: "hidden", borderRadius: "50%" }}>
        <StaticImage
          src="../../images/aj-thumbnail-sm.jpeg"
          width={35}
          height={35}
          quality={100}
          layout="fixed"
          alt="AJ Keller"
          title="AJ Keller"
          placeholder="none"
        />
      </Box>
      <Box
        fontSize={[14, 16, 16, 16]}
        ml={[3]}
        mt={[1]}
        color={colors.text}
      >
        By AJ Keller, CEO at Neurosity
        {publishedDate ? (
          <> &nbsp;&bull;&nbsp; {publishedDate}</>
        ) : null}
      </Box>
    </Flex>
  );
}
